export function base64toFile(dataurl,filename = 'file') {
    let arr = dataurl.split(',');
    let mime = arr[0].match(/:(.*?);/)[1];
    // suffix是该文件的后缀
    let suffix = mime.split('/')[1];
    // atob 对经过 base-64 编码的字符串进行解码
    let bstr = atob(arr[1]);
    // n 是解码后的长度
    let n = bstr.length;
    // Uint8Array 数组类型表示一个 8 位无符号整型数组 初始值都是 数子0
    let u8arr = new Uint8Array(n);
    // charCodeAt() 方法可返回指定位置的字符的 Unicode 编码。这个返回值是 0 - 65535 之间的整数
    while (n--) {
        u8arr[n] = bstr.charCodeAt(n);
    }
    // new File返回File对象 第一个参数是 ArraryBuffer 或 Bolb 或Arrary 第二个参数是文件名
    // 第三个参数是 要放到文件中的内容的 MIME 类型
    return new File([u8arr], `${filename}.${suffix}`, {
        type: mime,
    });
}
export function dataURLtoBlob(toDataURL) {
    var arr = toDataURL.split(","),
        mime = arr[0].match(/:(.*?);/)[1],
        bstr = atob(arr[1]),
        n = bstr.length,
        //new ArrayBuffer(bstr.length) 这里有争议，加上后后面blob转化为formData 的时候不是乱码形式的流，可以看到类似于就是formData的格式，但是提交后后台给的url图片显示不出来。不使用呢看请求参数的时候就是一堆乱码流，但是后台接口能够通过它正常放回图片路径。之前由于不懂这里直接用网上的代码，哎  后面研究一下，这个就搞了差不多一天。所以建议new ArrayBuffer(bstr.length)  这个可以用于临时调试看参数。实际使用还是使用bstr.length这个吧
        u8arr = new Uint8Array(n);
    while (n--) {
        u8arr[n] = bstr.charCodeAt(n);
    }
    return new Blob([u8arr], {
        type: mime
    });
}

export function getNowDate () {
    var date = new Date();
    var sign2 = ":";
    var year = date.getFullYear() // 年
    var month = date.getMonth() + 1; // 月
    var day = date.getDate(); // 日
    var hour = date.getHours(); // 时
    var minutes = date.getMinutes(); // 分
    var seconds = date.getSeconds() //秒
    var weekArr = ['星期一', '星期二', '星期三', '星期四', '星期五', '星期六', '星期天'];
    var week = weekArr[date.getDay()];
    // 给一位数的数据前面加 “0”
    if (month >= 1 && month <= 9) {
        month = "0" + month;
    }
    if (day >= 0 && day <= 9) {
        day = "0" + day;
    }
    if (hour >= 0 && hour <= 9) {
        hour = "0" + hour;
    }
    if (minutes >= 0 && minutes <= 9) {
        minutes = "0" + minutes;
    }
    if (seconds >= 0 && seconds <= 9) {
        seconds = "0" + seconds;
    }
    return year + "-" + month + "-" + day + " " + hour + sign2 + minutes + sign2 + seconds;
}
export function GetRequest (localUrl) {
    //url例⼦：XXX.aspx?ID=" + ID + "&Name=" + Name；
    var url = localUrl; //获取url中"?"符以及其后的字串
    var addressParameter = {};
    if (url.indexOf("?") != -1) {
        //url中存在问号，也就说有参数。
        var str;
        if (url.indexOf("=") != -1) {
            str = url.substr(1, url.indexOf("=") - 1);
        } else {
            str = url.substr(1);
        }
        //地址栏参数解密
        var addressUrl = decodeURIComponent(atob(str));
        var addressData = addressUrl.split("&");
        for (var i = 0; i < addressData.length; i++) {
            addressParameter[addressData[i].split("=")[0]] = unescape(
                addressData[i].split("=")[1]
            );
        }
    }
    return addressParameter;
}